import { useContext } from "react";
import { getMonthAbbreviations, getWeekdayAbbreviationsMonFri } from "../../functions/src/api/dates";
import { langContext } from "../api/Lang";

const el = {
    orderRemarksPlaceholder:
        "Αναφέρετε ιδιαίτερες προτιμήσεις για την παραγγελία σας",
    changeOrderDlgTitle: "Τροποποίηση Παραγγελίας",
    setMenuWarningMessage:
        "ΠΡΟΣΟΧΗ: Η παραγγελία σας περιλαμβάνει γεύματα από το βασικό μενού. Αν ακυρώσετε την παραγγελία σας, δεν θα μπορείτε να κάνετε νέα παραγγελία για γεύματα από το βασικό μενού για αυτή την ημέρα, καθώς έχει περάσει η προθεσμία.",
    fallbackOrderMenuWeekday: "Πέμπτη",
    singleOrdersUntilWeekdayPrefix: "Δεχόμαστε παραγγελίες, αλλαγές και ακυρώσεις μέχρι την ",
    singleTheWeekBeforeSuffix: " της προηγούμενης εβδομάδας.",
    singleOrdersUntilTimePrefix: "Δεχόμαστε παραγγελίες, αλλαγές και ακυρώσεις μέχρι τις ",
    singleSameDayNoRefundSuffix:
        " της ίδιας ημέρας. Δεν γίνεται επιστροφή Lunchbox Credits μετά από αυτή την ώρα.",
    singlePrevDayNoRefundSuffix:
        " της προηγούμενης ημέρας. Δεν γίνεται επιστροφή Lunchbox Credits μετά από αυτή την ώρα.",
    singleNDaysNoRefundSuffix:
        " ημέρες πριν. Δεν γίνεται επιστροφή Lunchbox Credits μετά από αυτή την ώρα.",
    doubleOrdersUntilWeekdayOneMenu: "Δεχόμαστε παραγγελίες μέχρι την ",
    doubleOrdersForSetMenusUntilPrefix: "Δεχόμαστε παραγγελίες για τα ",
    doubleStandardSetMenusUntil: " βασικά μενού μέχρι ",
    doubleStandardSetMenusUntilTime: " βασικά μενού μέχρι τις ",
    doubleTheWeekBefore: " της προηγούμενης εβδομάδας",
    doubleOrdersUntilTimeOneMenu: "Δεχόμαστε παραγγελίες μέχρι τις ",
    doubleTheSameDay: " της ίδιας ημέρας ",
    doubleThePrevDay: " της προηγούμενης ημέρας ",
    doubleNDaysBefore: " ημέρες πριν ",
    doubleDailyMealsUntil: " και για κάποια καθημερινά γεύματα μέχρι τις ",
    doubleDailySameDaySuffix: " της ίδιας ημέρας.",
    doubleDailyPrevDaySuffix: " της προηγούμενης ημέρας.",
    doubleDailyNDaysSuffix: " ημέρες πριν.",
    doubleCancelUntilWeekdayPrefix: "Δεχόμαστε ακυρώσεις μέχρι την ",
    doubleCancelWeekBeforeSuffix: " της προηγούμενης εβδομάδας.",
    doubleCancelUntilTimePrefix: "Δεχόμαστε ακυρώσεις μέχρι τις ",
    doubleCancelSameDayNoRefund:
        " της ίδιας ημέρας. Δεν γίνεται επιστροφή Lunchbox Credits μετά από αυτή την ώρα.",
    doubleCancelPrevDayNoRefund:
        " της προηγούμενης ημέρας. Δεν γίνεται επιστροφή Lunchbox Credits μετά από αυτή την ώρα.",
    doubleCancelNDaysNoRefund:
        " ημέρες πριν. Δεν γίνεται επιστροφή Lunchbox Credits μετά από αυτή την ώρα.",
    infoBoxTitle: "ΠΑΡΑΓΓΕΛΙΕΣ, ΑΛΛΑΓΕΣ ΚΑΙ ΑΚΥΡΩΣΕΙΣ",
    dismissOrderInfoAria: "Απόκρυψη πληροφοριών παραγγελίας",
    restoreOrderInfoAria: "Εμφάνιση πληροφοριών παραγγελίας",
    orderInformationTitle: "Πληροφορίες παραγγελίας",
    doubleLayoutOrdersHeading: "Παραγγελίες",
    doubleLayoutCancelHeading: "Ακυρώσεις",
    printWeekOrders: "Εκτύπωση παραγγελίας εβδομάδας",
    incompleteOrderEmptyState:
        'Ξεκίνησες παραγγελία για αυτή την ημέρα, αλλά δεν την πρόσθεσες στο καλάθι. Πάτα «Δες το καλάθι» και ολοκλήρωσε τις παραγγελίες σου από εκεί.',
    orderInfoTapForDeadlines:
        'Πάτα πάνω για ξεχωριστές προθεσμίες παραγγελιών και ακυρώσεων.',
    noOrderEmptyState: "Δεν τοποθετήθηκε καμία παραγγελία για αυτή την ημέρα",
    headingCompletedOrder: "ΟΛΟΚΛΗΡΩΜΕΝΗ ΠΑΡΑΓΓΕΛΙΑ",
    headingOrder: "ΠΑΡΑΓΓΕΛΙΑ",
    staffLabel: "Προσωπικό",
    addOrderAnotherBreak: "+ Προσθήκη παραγγελίας για άλλο διάλειμμα",
    remarksHeading: "ΠΑΡΑΤΗΡΗΣΕΙΣ",
    orderAmountLabel: "Σύνολο παραγγελίας:",
    insufficientBalance: "Το υπόλοιπό σου δεν επαρκεί για να ολοκληρώσεις την παραγγελία. ",
    fillSnackRecipient: "Συμπλήρωσε τον παραλήπτη για κάθε σνακ της παραγγελίας",
    clearChanges: "Ακύρωση αλλαγών",
    submitOrder: "Δες το καλάθι",
    cancelMyOrder: "Ακύρωση παραγγελίας",
    changeMyOrder: "Τροποποίηση παραγγελίας",
    sendChanges: "Δες το καλάθι",
    cateringTagline: "Η μοναδική γευστική εμπειρία παρέχεται από την Γευσήνους",
    gefsinusBannerCloseAria: "Κλείσιμο",
    cateringBullet1We: "",
    cateringBullet1Bold: "Φρεσκομαγειρεύουμε ",
    cateringBullet1Rest: "όλα τα γεύματα μας καθημερινά",
    cateringBullet2We: " Επιλέγουμε ",
    cateringBullet2Bold: "άριστες Α' ύλες ",
    cateringBullet2Rest: "με αυστηρά κριτήρια ποιότητας από πιστοποιημένους προμηθευτές",
    cateringBullet3We: " Τηρούμε τις υψηλότερες ",
    cateringBullet3Bold: "υγειονομικές προδιαγραφές ",
    cateringBullet3Rest: "και πιστοποιήσεις (ISO, OHSAS, ECOVADIS, FSCC)",
    packageValidUntil: "Ενεργό μέχρι ",
    packageChangeMeal: "Άλλαξε γεύμα",
    /** Per-line meal/snack remark icon (aria-label only). */
    orderItemRemarkAria: "Σχόλιο για το προϊόν",
    editSnacks: "Επεξεργασία Σνακ",
    chooseSnacks: "Επιλογή Σνακ",
    addExtraMeal: "Προσθήκη επιπλέον γεύματος",
    editMeal: "Επεξεργασία γεύματος",
    chooseMainMeal: "Επιλογή κυρίως γεύματος",
    deliveryOptionLabel: "Επιλογή παράδοσης",
    snackButtonLabel: "Σνακ",
    mealButtonLabel: "Κυρίως γεύμα",
    pricePlaceholder: "Τιμή €",
    itemsPlaceholder: "Τμχ",
    dlgDeleteMainMenuTitle: "Διαγραφή Κυρίως Μενού",
    dlgDeleteMainMenuMsg:
        "Εάν διαγράψεις αυτό το μενού, δε θα μπορέσεις να ξαναπαραγγείλεις από τα σετ μενού για αυτή την ημέρα. Είσαι σίγουρος ότι θέλεις να το διαγράψεις?",
    dlgChangeMainMenuTitle: "Αλλαγή Κυρίως Μενού",
    dlgChangeMainMenuMsg:
        "Εάν μειώσεις ποσότητα από αυτό το μενού, δε θα μπορέσεις να την αυξήσεις πάλι για αυτή την ημέρα. Είσαι σίγουρος ότι θέλεις να την αλλάξεις?",
    deliveryTimePlaceholder: "Ώρα παράδοσης",
    orderCompleteCancelHeading: "Ακύρωση παραγγελίας",
    orderCompleteCancelBeforeDate: "Η παραγγελία για την ",
    orderCompleteCancelAfterDate: " ακυρώθηκε.",
    orderCompleteCreditsRefunded: "Τα Lunchbox credits επιστράφηκαν στο λογαριασμό σου.",
    orderCompleteThankYou: "Ευχαριστούμε για την παραγγελία!",
    orderCompleteSuccessBeforeDate: "Η παραγγελία σας για την ",
    orderCompleteSuccessAfterDate: " ολοκληρώθηκε επιτυχώς.",
    orderCompleteContactPrefix: "Για οποιαδήποτε πληροφορία κάλεσέ μας στο ",
    orderCompleteContactBetween: " μεταξύ ",
    orderCompleteNewBalance: "Το νέο υπόλοιπο του λογαριασμού σου είναι",
    orderCompleteLowBalance: "Το υπόλοιπο του λογαριασμού σου είναι λιγότερο από 10€",
    orderCompleteRefillHere: "Μπορείς να το ανανεώσεις απευθείας από εδώ",
    orderCompleteReturnToOrders: "Επιστροφή στις παραγγελίες",
    statusCompleted: "Ολοκληρώθηκε",
    statusClosed: "Κλειστό σχολείο",
    statusIncomplete: "Δεν Ολοκληρώθηκε",
    /** Day strip — change mode, draft still matches placed order */
    statusChangingOrderNoEdits: "Χωρίς αλλαγές ακόμα",
    /** Day strip — change mode, draft differs from placed (basket checkout pending) */
    statusChangingOrderInBasket: "Αλλαγές στο καλάθι",
    changingOrderHintEyebrow: "Ενεργή παραγγελία",
    changingOrderHintTitle: "Η παραγγελία που έχεις ήδη καταχωρήσει για αυτή την ημέρα ισχύει ακόμα.",
    changingOrderHintNoEditsDetail:
        "Κάνε τις αλλαγές που θέλεις· όταν τελειώσεις, πάτα «Δες το καλάθι» για να τις στείλεις.",
    changingOrderHintInBasketDetail:
        "Οι αλλαγές σου είναι στο καλάθι· πάτα «Δες το καλάθι» και ολοκλήρωσε για να εφαρμοστούν.",
    statusChangingOrderEmptyInvalid: "Δεν επιτρέπεται κενή",
    changingOrderHintEmptyEyebrow: "Ενεργή παραγγελία",
    changingOrderHintEmptyTitle: "Η παραγγελία που έχεις ήδη καταχωρήσει για αυτή την ημέρα ισχύει ακόμα.",
    changingOrderHintEmptyDetail:
        "Δεν μπορείς να αδειάσεις την παραγγελία μέσα από την τροποποίηση. Πάτα «Ακύρωση αλλαγών» για να επανέλθεις. Για να ακυρώσεις την παραγγελία, χρησιμοποίησε «Ακύρωση παραγγελίας» από την ολοκληρωμένη παραγγελία σου — όχι την τροποποίηση.",
    statusAwaitingSubmit: "Στο καλάθι",
    printOrdersWord: "Παραγγελίες",
    printColDay: "Ημέρα",
    printColMeal: "Γεύμα",
    printColQty: "Ποσ.",
    printColSide: "Συν.",
    printColDessert: "Επιδ.",
    mealsPopupPackageMealLine1:
        "Έχεις ήδη ένα γεύμα επιλεγμένο από το πακέτο σίτισης σου.",
    mealsPopupPackageMealLine2:
        "Εάν θέλεις να το αντικαταστήσεις, πάτησε το κουμπί Αλλαγή στο γεύμα του πακέτου σου.",
    mealsPopupPackageMealLine3: "Διαφορετικά, μπορείς να πάρεις επιπλέον γεύματα από εδώ.",
    mealsPopupSetMenusHeading: "ΣΕΤ ΜΕΝΟΥ ΗΜΕΡΑΣ",
    mealsPopupAllergensList: "Λίστα με αλλεργιογόνα",
    mealsPopupAllergensLabel: "Αλλεργιογόνα",
    mealsPopupPackageOnlyNote: "* Διατίθενται μόνο όταν έχεις ενεργό πακέτο σίτισης",
    mealsPopupOneSetMenuDescription: "Κάθε μέρα προσφέρουμε ένα ολοκληρωμένο μενού για τους μαθητές.",
    mealsPopupSetMenusOfferPrefix: "Κάθε μέρα προσφέρουμε ",
    mealsPopupSetMenusOfferSuffix: " διαφορετικά ολοκληρωμένα μενού για τους μαθητές.",
    mealsPopupSetMenuCalloutEyebrow: "Μενού ημέρας",
    mealsPopupMenuDeadlineTitle: "Η προθεσμία για παραγγελία μενού ημέρας έχει περάσει.",
    mealsPopupMenuDeadlineDetail: "Μπορείς να επιλέξεις μόνο καθημερινά γεύματα τώρα.",
    mealsPopupSetMenusNotYetAvailable: "Τα Μενού Ημέρας δεν είναι ακόμα διαθέσιμα.",
    mealsPopupEverydayChoicesHeading: "ΚΑΘΗΜΕΡΙΝΕΣ ΕΠΙΛΟΓΕΣ",
    mealsPopupEverydayChoicesDescription: "Γεύματα, σαλάτες και συνοδευτικά.",
    mealsPopupSideDishLabel: "ΣΥΝΟΔΕΥΤΙΚΟ",
    mealsPopupDessertLabel: "ΕΠΙΔΟΡΠΙΟ",
    mealsPopupMenuWordLabel: "ΜΕΝΟΥ",
    packageMealsPopupChangeTitle: "Αλλαγή Γεύματος",
    packageMealsPopupIntro: "Μπορείς να αλλάξεις το γεύμα του πακέτου σου με ένα από τα παρακάτω",
    packageMealsPopupDishesHeading: "ΠΙΑΤΑ ΗΜΕΡΑΣ",
    packageMealsPopupClassicsHeading: "ΚΛΑΣΙΚΕΣ ΕΠΙΛΟΓΕΣ",
    packageMealsPopupSelected: "Επιλεγμένο",
    packageMealsPopupSelect: "Επιλογή",
    setDayMenuPopupBreakfastHeading: "ΠΡΩΙΝΟ",
    setDayMenuPopupMorningSnackHeading: "ΣΝΑΚ",
    setDayMenuPopupLunchHeading: "ΜΕΣΗΜΕΡΙΑΝΟ",
    setDayMenuPopupSnackNotAvailable: "Τα προϊόντα δεν είναι ακόμα διαθέσιμα.",
    setDayMenuPopupBreakfastIncluded: "Συμπεριλαμβάνεται 1 χυμός ανάμεικτος & 1 μπουκαλάκι νερό",
    setDayMenuPopupLunchWaterNote: "Συμπεριλαμβάνεται 1 μπουκαλάκι νερό",
    snacksPopupFewItemsLeft: (remaining: number) => `Απομένουν μόλις ${remaining} τμχ`,
    orderItemRemarksPlaceholder:
        "Πες μας τις ιδιαίτερες προτιμήσεις σου για το συγκεκριμένο προϊόν",
    /** Covid / operations notices (optional UI block). */
    covidMainCoursesNotice:
        "Το σχολείο, με βάση τα μέτρα προστασίας από τον Covid-19, έχει λάβει απόφαση να μην παρέχονται κυρίως γεύματα.",
    restaurantClosedUntilRegulations:
        "Η λειτουργία του εστιατορίου μας θα ξεκινήσει όταν το επιτρέψουν οι κανονισμοί του σχολείου.",
    canteenMenuDownload: "Κατάλογος κυλικείου",
    /** Shown when submit would add/increase set-menu meals after the menu deadline (see `onCompleteOrder` validation). */
    cannotPlaceSetMenuForDate:
        "Για αυτή την ημερομηνία δεν μπορείς πλέον να παραγγείλεις ή να αυξήσεις γεύματα από το μενού ημέρας με αυτόν τον τρόπο.",
    /** Generic fallback when `placeOrder` throws (unexpected errors). */
    placeOrderFailedTryAgain: "Η ολοκλήρωση της παραγγελίας απέτυχε. Παρακαλώ δοκίμασε ξανά.",
    /** School closed + package allows viewing: only meal exchange until deadline. */
    closedSchoolExchangeOnlyHint:
        "Το σχολείο λειτουργεί μόνο με πακέτα σίτισης και όχι με μεμονωμένες παραγγελίες. Για να αγοράσεις πακέτο γευμάτων, πήγαινε στην καρτέλα Πακέτα Σίτισης.",
    /** School closed + normal order placed: only cancel action is available. */
    closedSchoolCancelOnlyHint:
        "Το σχολείο είναι κλειστό για την ημέρα. Για αυτή την παραγγελία μπορείς μόνο να κάνεις ακύρωση.",
    /** Closed classroom on a recipient card: admin closedText + change-order steps. */
    recipientClassroomClosedIntro: (closedText: string) => `Κλειστή τάξη: ${closedText}.`,
    recipientClassroomClosedAction: (changeOrderLabel: string) =>
        `Πάτησε «${changeOrderLabel}», αφαίρεσε τα γεύματα και ολοκλήρωσε την παραγγελία.`,
    daySelectorDayAria: (weekday: string, dayOfMonth: string, month: string, selected: boolean) =>
        selected
            ? `${weekday} ${dayOfMonth} ${month}, επιλεγμένη`
            : `${weekday} ${dayOfMonth} ${month}`,
    /** Week navigation arrows in the day selector (aria-label only). */
    previousWeek: "Προηγούμενη εβδομάδα",
    nextWeek: "Επόμενη εβδομάδα",
    dayClosureAlertAria: "Κλειστό σχολείο ή τάξη — η παραγγελία σου επηρεάζεται",
};

const en: typeof el = {
    orderRemarksPlaceholder: "Mention any special preferences for your order",
    changeOrderDlgTitle: "Change Order",
    setMenuWarningMessage:
        "WARNING: Your order includes set menu meals. If you cancel your order, you will not be able to place a new order for set menu meals for this day, as the deadline has passed.",
    fallbackOrderMenuWeekday: "Thursday",
    singleOrdersUntilWeekdayPrefix: "We accept orders, changes and cancellations until ",
    singleTheWeekBeforeSuffix: " the week before.",
    singleOrdersUntilTimePrefix: " We accept orders, changes and cancelations until ",
    singleSameDayNoRefundSuffix:
        " the same day. After this time, we can't return any Lunchbox Credits.",
    singlePrevDayNoRefundSuffix:
        " the day before. After this time, we can't return any Lunchbox Credits.",
    singleNDaysNoRefundSuffix:
        " days before. After this time, we can't return any Lunchbox Credits.",
    doubleOrdersUntilWeekdayOneMenu: " We accept orders until ",
    doubleOrdersForSetMenusUntilPrefix: "We accept orders for the ",
    doubleStandardSetMenusUntil: " standard set menus until ",
    doubleStandardSetMenusUntilTime: " standard set menus until ",
    doubleTheWeekBefore: " the week before",
    doubleOrdersUntilTimeOneMenu: "We accept orders until ",
    doubleTheSameDay: " the same day",
    doubleThePrevDay: " the day before",
    doubleNDaysBefore: " days before",
    doubleDailyMealsUntil: " and for some daily meals until ",
    doubleDailySameDaySuffix: " the same day.",
    doubleDailyPrevDaySuffix: " the day before.",
    doubleDailyNDaysSuffix: " days before.",
    doubleCancelUntilWeekdayPrefix: "We accept orders, changes and cancellations until ",
    doubleCancelWeekBeforeSuffix: " the week before.",
    doubleCancelUntilTimePrefix: " We accept cancelations until ",
    doubleCancelSameDayNoRefund:
        " the same day. After this time, we can't return any Lunchbox Credits.",
    doubleCancelPrevDayNoRefund:
        " the day before. After this time, we can't return any Lunchbox Credits.",
    doubleCancelNDaysNoRefund:
        " days before. After this time, we can't return any Lunchbox Credits.",
    infoBoxTitle: "ORDERS, CHANGES AND CANCELATIONS",
    dismissOrderInfoAria: "Dismiss order information",
    restoreOrderInfoAria: "Show order information",
    orderInformationTitle: "Order information",
    doubleLayoutOrdersHeading: "Orders",
    doubleLayoutCancelHeading: "Cancelations",
    printWeekOrders: "Print Week's Order",
    incompleteOrderEmptyState:
        'You started an order for this day but didn\'t add it to your basket. Tap "View basket" and complete checkout from there.',
    orderInfoTapForDeadlines:
        'Tap above for separate order and cancellation deadlines.',
    noOrderEmptyState: "You haven't placed an order for this day",
    headingCompletedOrder: "COMPLETED ORDER",
    headingOrder: "ORDER",
    staffLabel: "Staff",
    addOrderAnotherBreak: "+ Add order for another school break",
    remarksHeading: "REMARKS",
    orderAmountLabel: "Order amount",
    insufficientBalance: "You have insufficient balance to complete your order. ",
    fillSnackRecipient: "Please fill in the recipient for every snack of your order",
    clearChanges: "Cancel Changes",
    submitOrder: "View basket",
    cancelMyOrder: "Cancel my Order",
    changeMyOrder: "Change my Order",
    sendChanges: "View basket",
    cateringTagline: "The unique tasting experience is offered by Gefsinus",
    gefsinusBannerCloseAria: "Close",
    cateringBullet1We: "We ",
    cateringBullet1Bold: "freshly cook ",
    cateringBullet1Rest: "all our meals on a daily basis",
    cateringBullet2We: " We select ",
    cateringBullet2Bold: "premium-quality ",
    cateringBullet2Rest: "raw materials according to strict quality criteria from certified suppliers",
    cateringBullet3We: " We adhere to the highest ",
    cateringBullet3Bold: "health standards ",
    cateringBullet3Rest: "and Certifications (ISO, OHSAS, ECOVADIS, FSCC)",
    packageValidUntil: "Valid until ",
    packageChangeMeal: "Change meal",
    orderItemRemarkAria: "Remark for this item",
    editSnacks: "Edit Snacks",
    chooseSnacks: "Choose Snacks",
    addExtraMeal: "Add extra meal",
    editMeal: "Edit meal",
    chooseMainMeal: "Choose meal",
    deliveryOptionLabel: "Delivery option",
    snackButtonLabel: "Snack",
    mealButtonLabel: "Main meal",
    pricePlaceholder: "Price €",
    itemsPlaceholder: "Items",
    dlgDeleteMainMenuTitle: "Delete Main Menu",
    dlgDeleteMainMenuMsg:
        "If you delete this menu, you will not be able to reorder from the set menus for this day. Are you sure you want to delete it?",
    dlgChangeMainMenuTitle: "Change Main Menu",
    dlgChangeMainMenuMsg:
        "If you reduce quantity for this menu, you will not be able to increase it again for this day. Are you sure you want to change it?",
    deliveryTimePlaceholder: "Delivery time",
    orderCompleteCancelHeading: "Order cancelation",
    orderCompleteCancelBeforeDate: "Your order for ",
    orderCompleteCancelAfterDate: " has been cancelled.",
    orderCompleteCreditsRefunded: "The Lunchbox credits have been refunded.",
    orderCompleteThankYou: "Thank you for your order!",
    orderCompleteSuccessBeforeDate: "Your order for ",
    orderCompleteSuccessAfterDate: " has been completed successfully.",
    orderCompleteContactPrefix: "Please don't hesitate to contact us at ",
    orderCompleteContactBetween: " between ",
    orderCompleteNewBalance: "Your new balance is",
    orderCompleteLowBalance: "The balance of your account is less than 10€",
    orderCompleteRefillHere: "You may refill your account from here",
    orderCompleteReturnToOrders: "Return to Orders",
    statusCompleted: "Completed",
    statusClosed: "School closed",
    statusIncomplete: "Incomplete",
    statusChangingOrderNoEdits: "No changes yet",
    statusChangingOrderInBasket: "Changes in basket",
    changingOrderHintEyebrow: "Active order",
    changingOrderHintTitle: "The order you already placed for this day is still in effect.",
    changingOrderHintNoEditsDetail:
        "Make the changes you want; when you're done, tap \"View basket\" to submit them.",
    changingOrderHintInBasketDetail:
        "Your changes are in the basket — tap \"View basket\" and complete checkout to apply them.",
    statusChangingOrderEmptyInvalid: "Can't be empty",
    changingOrderHintEmptyEyebrow: "Active order",
    changingOrderHintEmptyTitle: "The order you already placed for this day is still in effect.",
    changingOrderHintEmptyDetail:
        "You can't clear your order while changing it. Tap \"Cancel Changes\" to go back. To cancel this day's order, use \"Cancel my Order\" on your completed order — not Change my Order.",
    statusAwaitingSubmit: "In basket",
    printOrdersWord: "Orders",
    printColDay: "Day",
    printColMeal: "Meal",
    printColQty: "Qu.",
    printColSide: "Side",
    printColDessert: "Dessert",
    mealsPopupPackageMealLine1: "You already have a meal selected from your meal plan.",
    mealsPopupPackageMealLine2:
        "If you want to replace it, click the Change button on the meal in your plan.",
    mealsPopupPackageMealLine3: "Alternatively, you can get additional meals from here.",
    mealsPopupSetMenusHeading: "TODAY'S SET MENUS",
    mealsPopupAllergensList: "List of allergens",
    mealsPopupAllergensLabel: "Allergens",
    mealsPopupPackageOnlyNote: "* Available only if you have a valid meal package",
    mealsPopupOneSetMenuDescription: "We offer one set menu for the students every day.",
    mealsPopupSetMenusOfferPrefix: "We offer ",
    mealsPopupSetMenusOfferSuffix: " different set menus for the students every day.",
    mealsPopupSetMenuCalloutEyebrow: "Set menus",
    mealsPopupMenuDeadlineTitle: "The deadline for ordering menu meals has passed.",
    mealsPopupMenuDeadlineDetail: "You may only select everyday meals now.",
    mealsPopupSetMenusNotYetAvailable: "Set Menu meals are not available yet.",
    mealsPopupEverydayChoicesHeading: "EVERYDAY CHOICES",
    mealsPopupEverydayChoicesDescription: "Meals, salads and side dishes.",
    mealsPopupSideDishLabel: "SIDE DISH",
    mealsPopupDessertLabel: "DESSERT",
    mealsPopupMenuWordLabel: "MENU",
    packageMealsPopupChangeTitle: "Change meal",
    packageMealsPopupIntro: "You may change the meal of your subscription with any of the following meals",
    packageMealsPopupDishesHeading: "TODAY'S DISHES",
    packageMealsPopupClassicsHeading: "ALL TIME CLASSICS",
    packageMealsPopupSelected: "Selected",
    packageMealsPopupSelect: "Select",
    setDayMenuPopupBreakfastHeading: "BREAKFAST",
    setDayMenuPopupMorningSnackHeading: "MORNING SNACK",
    setDayMenuPopupLunchHeading: "LUNCH",
    setDayMenuPopupSnackNotAvailable: "Snack choices are not available yet.",
    setDayMenuPopupBreakfastIncluded: "Includes 1 mixed juice & 1 bottle of water",
    setDayMenuPopupLunchWaterNote: "Includes 1 bottle of water",
    snacksPopupFewItemsLeft: (remaining: number) => `Only ${remaining} items left`,
    orderItemRemarksPlaceholder: "Mention your special preferences for this specific item",
    covidMainCoursesNotice:
        "The school, based on the protection measures by Covid-19, has decided that main courses must not be consumed inside the school.",
    restaurantClosedUntilRegulations:
        "The operation of our restaurant will start when the school regulations allow it.",
    canteenMenuDownload: "Canteen menu",
    cannotPlaceSetMenuForDate:
        "For this date you can no longer order or increase daily set-menu meals in this way.",
    placeOrderFailedTryAgain: "Failed to complete your order. Please try again.",
    closedSchoolExchangeOnlyHint:
        "The school operates only with meal packages and not with individual orders. To purchase a meal package, go to the Meal Packages tab.",
    closedSchoolCancelOnlyHint:
        "School is closed for the day. For this order, only cancellation is available.",
    recipientClassroomClosedIntro: (closedText: string) => `Classroom closed: ${closedText}.`,
    recipientClassroomClosedAction: (changeOrderLabel: string) =>
        `Press «${changeOrderLabel}», remove the meals and submit the order.`,
    daySelectorDayAria: (weekday: string, dayOfMonth: string, month: string, selected: boolean) =>
        selected
            ? `${weekday} ${dayOfMonth} ${month}, selected`
            : `${weekday} ${dayOfMonth} ${month}`,
    previousWeek: "Previous week",
    nextWeek: "Next week",
    dayClosureAlertAria: "School or classroom closed — your order is affected",
};

const orderLangs = { el, en };

export function useOrderStrings() {
    const [lang] = useContext(langContext);
    return {
        ...orderLangs[lang],
        weekdayAbbr: getWeekdayAbbreviationsMonFri(lang),
        monthAbbr: getMonthAbbreviations(lang),
    };
}
